import { useState } from "react";
import { motion } from "framer-motion";

const pencil = { fill: "none", stroke: "#12303B", strokeWidth: 3.5, strokeLinejoin: "round", strokeLinecap: "round" };

export const LogoMark = ({ className = "w-10 h-10", drawing = false }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#F4C64E" />
    <motion.path
      d="M14 55c4-6 7-6 9 0s5 6 8 0 6-6 9 0 5 6 9 0"
      fill="none" stroke="#E8615A" strokeWidth="3" strokeLinecap="round"
      initial={false}
      animate={{ pathLength: drawing ? 1 : 0, opacity: drawing ? 1 : 0 }}
      transition={{ duration: drawing ? 0.8 : 0.3, ease: "easeInOut" }}
    />
    <motion.g
      initial={false}
      animate={drawing ? { x: [0, 8, 16, 24, 32, 0], y: [-4, -2, -4, -2, -4, 0] } : { x: 0, y: 0 }}
      transition={drawing ? { duration: 1.3, ease: "easeInOut", times: [0, 0.15, 0.3, 0.45, 0.6, 1] } : { duration: 0.3 }}
    >
      <g {...pencil}>
        <path d="M40 12l12 12-24 24-12-12z" fill="#FBF6EA" />
        <path d="M16 36l-4 16 16-4" fill="#FBF6EA" />
        <path d="M14 44l6 6" />
        <path d="M36 16l12 12" />
      </g>
    </motion.g>
  </svg>
);

export const Logo = ({ href = "#top" }) => {
  const [drawing, setDrawing] = useState(false);
  return (
    <a href={href} data-testid="nav-logo" className="flex items-center gap-3"
      onMouseEnter={() => setDrawing(true)} onMouseLeave={() => setDrawing(false)}>
      <LogoMark className="w-10 h-10" drawing={drawing} />
      <span className="font-display text-xl sm:text-2xl leading-none text-butter tracking-wide whitespace-nowrap">Reuben's Reads</span>
    </a>
  );
};
